import { categories } from "@/mocks/stories";
import Reveal from "@/components/base/Reveal";

interface CategoriesProps {
  onSelect: (catKey: string) => void;
}

const tints = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
  "bg-background-200 text-foreground-700",
  "bg-primary-50 text-primary-600",
  "bg-accent-200/70 text-accent-900",
];

export default function Categories({ onSelect }: CategoriesProps) {
  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-semibold text-primary-700">
                <i className="ri-grid-fill"></i> 按口味吃瓜
              </span>
              <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">你是哪种吃瓜选手？</h2>
            </div>
            <p className="max-w-md text-sm text-foreground-600 md:text-right">
              选一个口味，直达今日对应分类的爆梗，找到最懂你的笑点。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <Reveal key={c.key} delay={(i % 3) * 60}>
              <button
                onClick={() => onSelect(c.key)}
                className="group flex w-full items-center gap-4 rounded-3xl bg-background-100 p-5 text-left transition-transform duration-200 hover:-translate-y-1"
              >
                <span className={`grid h-14 w-14 shrink-0 place-items-center rounded-2xl text-2xl ${tints[i % tints.length]}`}>
                  <span aria-hidden="true">{c.emoji}</span>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block font-heading text-xl text-foreground-950">{c.label}</span>
                  <span className="mt-0.5 block truncate text-sm text-foreground-600">{c.tagline}</span>
                </span>
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-background-50 text-foreground-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}